import api from "@/services/api";
const initialState = () => ({
  buyFlag: false,
  acceptOfferFlag: false,
  currentStep: 1,
  currentStepAcceptOffer: 1,
  currentStepsArray: [
    {
      component: "BuyNft",
    },
    {
      component: "Completing",
    },
  ],
  currentStepsArrayAcceptOffer: [
    {
      component: "AcceptOffer",
    },
    {
      component: "AcceptOfferCompleting",
    },
  ],
  nft: {
    coverImage: {
      path: String,
    },
    name: String,
    pools: [],
  },
  pool: {
    basePrice: 0,
    tokenName: "",
    NftPoolModel: {},
  },
  errors: [],
});

const state = initialState();
const getters = {
  getByKey: (state) => (key) => state[key],
};
const mutations = {
  setByKey(state, obj) {
    state[obj.key] = obj.value;
  },
  toggleBuyFlag(state) {
    state.buyFlag = !state.buyFlag;
  },
  toggleAcceptOfferFlag(state) {
    state.acceptOfferFlag = !state.acceptOfferFlag;
  },
  incrementStep(state) {
    state.currentStep++;
  },
  incrementStepAcceptOffer(state) {
    state.currentStepAcceptOffer = Math.min(
      state.currentStepsArrayAcceptOffer.length,
      ++state.currentStepAcceptOffer
    );
  },
  decrementStep(state) {
    state.currentStep--;
  },
  decrementStepAcceptOffer(state) {
    state.currentStepAcceptOffer = Math.max(1, --state.currentStepAcceptOffer);
  },
  commitByKey(state, object) {
    Object.keys(object).forEach((key) => (state[key] = object[key]));
  },
  resetState(state) {
    Object.assign(state, initialState());
  },
  pushError(state, error) {
    state.errors.push(error);
  },
  clearErrors(state) {
    state.errors.splice(0);
  },
};
const actions = {
  setByKey({ commit }, obj) {
    commit("setByKey", obj);
  },
  incrementStep({ commit }) {
    commit("incrementStep");
  },
  incrementStepAcceptOffer({ commit }) {
    commit("incrementStepAcceptOffer");
  },
  decrementStep({ commit }) {
    commit("decrementStep");
  },
  decrementStepAcceptOffer({ commit }) {
    commit("decrementStepAcceptOffer");
  },
  commitByKey({ commit }, object) {
    commit("commitByKey", object);
  },
  resetState({ commit }) {
    commit("resetState");
  },
  toggleBuyFlag({ commit }) {
    try {
      commit("toggleBuyFlag");
    } catch (error) {
      commit("pushError", error);
    }
  },
  toggleAcceptOfferFlag({ commit }) {
    try {
      commit("toggleAcceptOfferFlag");
    } catch (error) {
      commit("pushError", error);
    }
  },
  async fetchNft({ commit }, id) {
    try {
      const response = await api.fetchNft(id);
      commit("commitByKey", { nft: response.data });
      if (response.data.pools && response.data.pools.length) {
        commit("commitByKey", { pool: response.data.pools[0] });
      }
      return response;
    } catch (error) {
      commit("pushError", error);
    }
  },
  async buyNft({ commit }, data) {
    try {
      return await api.buyNft(data);
    } catch (error) {
      commit("pushError", error);
    }
  },
};
export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
};
